/*
 * ez-card-hover — morph-safe hover-image loader for ez-product-card OUTSIDE a rail host.
 *
 * The ez-product-card's 2nd-angle hover image ships with NO src (only data-ez-hover-src) so it costs
 * nothing until hover. On a Product rail / listing the <ez-product-rail> engine sets that src on
 * hover-intent. In a surface with NO rail host — the predictive-search popup — this document-level
 * DELEGATED listener does the same job. Because the listener lives on document (never on the cards),
 * it keeps working across the predictive-search section morph/re-render: the cards are replaced on
 * every keystroke, the listener never is (the bug-139 class the element-bound engine can't guarantee).
 *
 * Scope: only cards NOT inside an <ez-product-rail> (the rail engine owns those). Pointer/hover devices
 * only, so a touch tap never fetches a hover image it can't reveal (the reveal is @media (hover:hover)).
 * Idempotent + define-once.
 */
(function () {
  if (window.__ezCardHoverBound) return;
  window.__ezCardHoverBound = true;

  // The hover reveal is desktop-hover only (matches the card CSS @media (hover: hover)); skip touch
  // devices so we never fetch an image that would stay hidden.
  if (!(window.matchMedia && window.matchMedia('(hover: hover)').matches)) return;

  document.addEventListener(
    'pointerover',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var media = target.closest('.ez-card__media');
      if (!media) return;
      // A card inside a rail host is wired by ez-product-rail.js — leave those to the engine.
      if (media.closest('ez-product-rail')) return;
      var hoverImg = media.querySelector('.ez-card__img--hover[data-ez-hover-src]');
      if (!hoverImg || hoverImg.getAttribute('src')) return;
      hoverImg.setAttribute('src', hoverImg.getAttribute('data-ez-hover-src'));
    },
    { passive: true }
  );
})();
